// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4d0e1189","239":"57a8bcba","455":"5c4e63a6"}[chunkId] + ".chunk.js";
};